// @ts-nocheck
import PropTypes from "prop-types";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {BaseButton} from "@/components";

const btnRowCls = "w-full px-2 pb-2 pt-0.5";
const btnCardResultsCls = "!w-full !h-7 !text-[10px] !font-bold !min-h-0 !py-0 !rounded-full !tracking-tight !border !border-[var(--color-accent-magenta)] !text-[var(--color-accent-magenta)] !bg-transparent hover:!bg-[linear-gradient(90deg,rgba(250,84,0,0.9)_0%,rgba(215,50,168,0.9)_100%)] hover:!text-white hover:!border-transparent hover:!shadow-[0_4px_14px_rgba(215,50,168,0.45)]";
const cardCls =
  "relative w-full flex flex-col overflow-hidden rounded-2xl bg-[linear-gradient(160deg,var(--color-gray-5)_0%,var(--color-gray-6)_100%)] border border-[rgba(255,255,255,0.07)] shadow-[0_4px_16px_rgba(0,0,0,0.45),inset_0_1px_0_rgba(255,255,255,0.07)] transition-[transform,box-shadow,border-color] duration-200";
const cardActiveCls =
  "-translate-y-1 border-[rgba(253,238,51,0.32)] shadow-[0_8px_28px_rgba(0,0,0,0.65),0_0_0_1.5px_rgba(253,238,51,0.28),inset_0_1px_0_rgba(255,255,255,0.1)]";
const cardImageCls = "w-full aspect-square object-contain block p-2.5";

const Title = ({onResultsClick}: {onResultsClick: () => void}) => (
  <div className={btnRowCls}>
    <BaseButton
      variant="secondary"
      className={btnCardResultsCls}
      onClick={e => {
        e.stopPropagation();
        onResultsClick();
      }}
    >
      Resultados
    </BaseButton>
  </div>
);



const GameCard = ({gameId, gameUuid, name, provider, icon, enable, isSelected, onGameSelect}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleNavigateToResults = () => navigate(`/lottery/${gameUuid}/results`);

  const handleCardClick = () => {
    if (enable && onGameSelect) {
      onGameSelect(gameId);
    }
  };

  const isActive = isSelected || isHovered;

  return (
    <div
      className={isActive ? `${cardCls} ${cardActiveCls}` : cardCls}
      style={{cursor: enable ? "pointer" : "not-allowed", opacity: enable ? 1 : 0.6}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardClick();
        }
      }}
      role="button"
      tabIndex={enable ? 0 : -1}
      aria-disabled={!enable}
    >
      <img
        alt={`${name} - ${provider}`}
        src={icon}
        className={cardImageCls}
      />
      <Title onResultsClick={handleNavigateToResults} />
    </div>
  );
};

GameCard.propTypes = {
  gameId: PropTypes.string.isRequired,
  gameUuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isFav: PropTypes.bool.isRequired,
  enable: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  onGameSelect: PropTypes.func,
};

export default GameCard;
